'use strict';

export function OrganizationInviteAccessCodeDomainProvider() {
  return {
    $get: [
      '$injector',
      'AbstractDomainClass',
      'fetchUtils',
      function (
        $injector,
        AbstractDomainClass,
        fetchUtils,
        ) {

        function OrganizationInviteAccessCodeDomain(data) {
          AbstractDomainClass.call(this, OrganizationInviteAccessCodeDomain, data);
        }

        AbstractDomainClass.__inheritFrom(OrganizationInviteAccessCodeDomain, 'OrganizationInviteAccessCodeDomain', 'organization-invite-access-codes');

        OrganizationInviteAccessCodeDomain.$constraints.addConstraints({
          organizationName: {type: 'string'},
          inviterName: {type: 'string'},
          inviteeName: {type: 'string'},
          inviteeEmail: {type: 'email'},
          inviteId: {type: 'string'},
          expires: {type: 'Date'},

          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        OrganizationInviteAccessCodeDomain.requestNewCode = function requestNewCode(accessCode) {
          const url = `${fetchUtils.API_URL}/api/organization-invite-code-refresh/${accessCode}`;
          const request = {
            method: 'PUT',
            mode: 'cors',
            cache: 'default',
          };

          return fetchUtils.request(url, request);
        };

        OrganizationInviteAccessCodeDomain.prototype.requestNewCode = function requestNewCode() {
          return OrganizationInviteAccessCodeDomain.requestNewCode(this.$id);
        };

        OrganizationInviteAccessCodeDomain.prototype.associateUser = function associateUser() {
          const url = `${fetchUtils.API_URL}/api/organization-invite-codes/${this.$id}/acknowledge`;
          const request = {
            method: 'PUT',
            mode: 'cors',
            cache: 'default',
          };

          return fetchUtils.requestWithAuth(url, request);
        };

        return OrganizationInviteAccessCodeDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/organizations/domain/OrganizationInviteAccessCodeDomain.js